module.exports = __webpack_public_path__ + "img/VideoTitleActivity.3ffa783b.png";